import { useStore } from 'effector-react'
import { inspectionModel, Header } from '~/entities/Inspection'
import { Photos } from './ui/Photos'

export function BookingCarViewInspection() {
  const inspection = useStore(inspectionModel.$inspection)

  if (!inspection) return null

  return (
    <>
      <Header />

      <Photos />
    </>
  )
}
